import axios from "../utils/axios";

/**
 * Login - Admin Authentication
 * @param {Object} credentials - { email, password }
 * @returns {Promise} Response with token and user data
 */
export const authLogin = async (credentials) => {
    try {
        const { data } = await axios.post('/auth/login', credentials);
        return data;
    } catch (error) {
        console.error("🚀 ~ authLogin ~ error:", error);
        throw error;
    }
};

/**
 * Register - User Registration
 * @param {Object} userData - { name, email, phone, password, password_confirmation, role }
 * @returns {Promise} Response with token and user data
 */
export const authRegister = async (userData) => {
    try {
        const { data } = await axios.post('/auth/register', userData);
        return data;
    } catch (error) {
        console.error("🚀 ~ authRegister ~ error:", error);
        throw error;
    }
};

/**
 * Logout - Revoke current access token
 * @returns {Promise} Response confirming logout
 */
export const authLogout = async () => {
    try {
        const { data } = await axios.post('/auth/logout');
        return data;
    } catch (error) {
        console.error("🚀 ~ authLogout ~ error:", error);
        throw error;
    }
};

/**
 * Get Current User - Retrieve authenticated user's information
 * @returns {Promise} Response with user data and abilities
 */
export const authMe = async () => {
    try {
        const { data } = await axios.get('/auth/me');
        return data;
    } catch (error) {
        console.error("🚀 ~ authMe ~ error:", error);
        throw error;
    }
};

/**
 * Update Password - Change the authenticated user's password.
 * Backend returns 422 with `errors.current_password` when the
 * current value is wrong; the form maps that to a field error.
 *
 * @param {Object} payload - { current_password, new_password, new_password_confirmation }
 */
export const updatePassword = async (payload) => {
    const { data } = await axios.put('/user/password', payload);
    return data;
};
